import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorLowerDiagram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M2.75 10.5c0-.966.784-1.75 1.75-1.75h1.8c.966 0 1.75.784 1.75 1.75v10a1.75 1.75 0 0 1-1.75 1.75H4.5a1.75 1.75 0 0 1-1.75-1.75v-10Zm1.75-.25a.25.25 0 0 0-.25.25v10c0 .138.112.25.25.25h1.8a.25.25 0 0 0 .25-.25v-10a.25.25 0 0 0-.25-.25H4.5ZM9.75 12.5c0-.966.784-1.75 1.75-1.75h1.7c.966 0 1.75.784 1.75 1.75v8a1.75 1.75 0 0 1-1.75 1.75h-1.7a1.75 1.75 0 0 1-1.75-1.75v-8Zm1.75-.25a.25.25 0 0 0-.25.25v8c0 .138.112.25.25.25h1.7a.25.25 0 0 0 .25-.25v-8a.25.25 0 0 0-.25-.25h-1.7ZM18.2 13.75a1.75 1.75 0 0 0-1.75 1.75v5c0 .967.784 1.75 1.75 1.75h1.6a1.75 1.75 0 0 0 1.75-1.75v-5a1.75 1.75 0 0 0-1.75-1.75h-1.6Zm-.25 1.75a.25.25 0 0 1 .25-.25h1.6a.25.25 0 0 1 .25.25v5a.25.25 0 0 1-.25.25h-1.6a.25.25 0 0 1-.25-.25v-5Z"
    />
    <path
      fill="#F7A600"
      d="M5.13 1.886a.75.75 0 1 0-.86 1.228l6.109 4.277a.75.75 0 0 0 .96-.084l1.081-1.081 5.676 4.002h-1.765a.75.75 0 0 0 0 1.5h3.58a.75.75 0 0 0 .75-.75v-3.58a.75.75 0 0 0-1.5 0v1.744l-6.393-4.506a.75.75 0 0 0-.962.083L10.724 5.8 5.13 1.886Z"
    />
  </svg>
);
export default SvgTwoColorLowerDiagram;
